<template>
  <v-card>
    <v-card-title>
      <v-btn
        color="success"
        @click="openUtilityCompanyForm('new')"
        :disabled="loading"
        small
        outline
        slot="end"
      >
        <v-icon class="pr-1">receipt_long</v-icon>Adicionar
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="utilityCompanies"
      :search="search"
      :pagination.sync="pag"
    >
      <template v-slot:items="props">
        <td>{{ props.item.name }}</td>
        <td>{{ props.item.id }}</td>
        <td>{{ props.item.state }}</td>
        <td>{{ props.item.mainCooperative }}</td>
        <td>{{ props.item.secondaryCooperative }}</td>
        <td>{{ props.item.email }}</td>
        <td>{{ props.item.phone }}</td>
        <td>{{ props.item.site }}</td>
        <td>{{ props.item.attendance_url }}</td>
        <td class="text-xs-right">
          <v-btn
            flat
            icon
            color="grey darken-1"
            @click="openUtilityCompanyForm('edit', props.item)"
            :disabled="loading"
          >
            <v-icon>edit</v-icon>
          </v-btn>
          <v-tooltip bottom v-if="props.item.status !== 'canceled'">
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                color="grey darken-1"
                :disabled="loading"
                v-on="on"
              >
                <v-icon
                  left
                  @click.stop="startUpdate(props.item.id, props.item.status)"
                  color="error"
                >
                  delete
                </v-icon>
              </v-btn>
            </template>
            <span>Cancelar Concessionária</span>
          </v-tooltip>

          <v-tooltip bottom v-else>
            <template v-slot:activator="{ on }">
              <v-btn
                flat
                icon
                color="grey darken-1"
                :disabled="loading"
                v-on="on"
              >
                <v-icon
                  left
                  @click.stop="startUpdate(props.item.id, props.item.status)"
                  color="success"
                >
                  restore_from_trash
                </v-icon>
              </v-btn>
            </template>
            <span>Reativar Concessionária</span>
          </v-tooltip>
        </td>
      </template>

      <template v-slot:no-results>
        <v-alert :value="true" color="error" icon="warning">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </template>
    </v-data-table>
    <v-dialog v-model="dialog_modify_status" max-width="290" dark>
      <v-card color="red">
        <v-card-title class="headline"
          >Tem certeza que deseja
          {{ newStatus !== "canceled" ? "ativar" : "cancelar" }} essa
          concessionária?</v-card-title
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="black darken-1"
            @click="dialog_modify_status = false"
            dark
          >
            Não
          </v-btn>

          <v-btn color="black darken-1" dark @click="cancelOrReactivate()">
            Sim
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <utility-company-form />
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import { eventBus } from "@/main";
import { updateUtilityCompanyFb } from "../../services/utilityCompanies";
import UtilityCompanyForm from "./UtilityCompanyForm.vue";

export default {
  components: { UtilityCompanyForm },
  data() {
    return {
      search: "",
      headers: [
        {
          text: "Nome",
          align: "left",
          sortable: false,
          value: "name",
        },
        {
          text: "ID",
          value: "id",
        },
        {
          text: "Estado de Atuação",
          value: "state",
        },
        {
          text: "Cooperativa Principal",
          value: "mainCooperative",
        },
        {
          text: "Cooperativa Secundária",
          value: "secondaryCooperative",
        },
        {
          text: "E-mail de Contato",
          value: "email",
        },
        {
          text: "Telefone de Contato",
          value: "phone",
        },
        {
          text: "Site",
          value: "site",
        },
        {
          text: "URL do Canal de atendimento",
          value: "attendance_url",
        },
      ],
      pag: {
        rowsPerPage: 50,
      },
      dialog_modify_status: false,
      newStatus: null,
      utilityCompanyId: null,
    };
  },
  computed: {
    ...mapState("configuration", ["loading", "utilityCompanies"]),
  },
  mounted() {
    this.getUtilityCompanies();
  },
  methods: {
    ...mapActions("configuration", ["getUtilityCompanies"]),

    startUpdate(id, status) {
      if (status === "canceled") status = "activated";
      else status = "canceled";

      (this.newStatus = status), (this.utilityCompanyId = id);
      this.dialog_modify_status = true;
    },

    cancelOrReactivate() {
      if (this.newStatus === "canceled") {
        this.cancelUtilityCompany(this.utilityCompanyId);
        this.dialog_modify_status = false;
      } else {
        this.reactivateUtilityCompany(this.utilityCompanyId);
        this.dialog_modify_status = false;
      }
    },

    openUtilityCompanyForm(type, data) {
      let obj = {
        status: true,
        type: type,
        data: data,
      };
      eventBus.$emit("utilityCompanyForm", obj);
    },

    cancelUtilityCompany(id) {
      let data = {
        updated_at: new Date(),
        status: "canceled",
      };
      updateUtilityCompanyFb(id, data);
    },

    reactivateUtilityCompany(id) {
      let data = {
        updated_at: new Date(),
        status: "activated",
      };
      updateUtilityCompanyFb(id, data);
    },

    cooperativeText(item) {
      return `${item.name} - ${item.state}`;
    },
  },
};
</script>
